<template>
  <div class="box">
    <div class="header">
      <div class="title">{{ i18n.blockchainexplorer }}</div>
      <div class="search_box">
        <!-- <div class="left">
          {{ i18n.AllFilters }}
          <img src="../../image/homePage/path.png" alt="" @click="showQuery = !showQuery" />
          <div class="popup" v-show="showQuery">
            <div class="sjx"></div>
            <div class="popList">
              <div class="list" @click="goOnChainQuery(1)">{{ i18n.address }}</div>
              <div class="list" @click="goOnChainQuery(2)">{{ i18n.transaction }}</div>
              <div class="list" @click="goOnChainQuery(3)">{{ i18n.block }}</div>
            </div>
          </div>
        </div> -->
        <input type="text" v-model="content" :placeholder="placeholder" @keyup.enter="identifyInputType" />
        <img class="Allsearch" src="../../image/homePage/Allsearch.png" alt="" @click="identifyInputType" />
      </div>
      <div class="desc">{{ i18n.desc }}</div>
    </div>
    <!-- <div class="queryList">
      <div class="list" :class="{ listActive: queryActive === item.id }" v-for="item in queryList" :key="item.id" @click="changeQueryActive(item)">
        {{ item.name }}
      </div>
    </div> -->
    <div class="infoBox">
      <!-- 地址查询 -->
      <div class="info" v-if="queryActive === 1">
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.Owner }}：</div>
            <div class="con">{{ info.Owner }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.control }}：</div>
            <div class="con">{{ info.Grant }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.accounttype }}：</div>
            <div class="con" v-if="info.Type === 0">{{ i18n.Controlaccount }}</div>
            <div class="con" v-if="info.Type === 1">{{ i18n.Contractaccount }}</div>
            <div class="con" v-if="info.Type === 2">{{ i18n.Trustmachineaccount }}</div>
            <div class="con" v-if="info.Type === 3">{{ i18n.Typeaccount }}</div>
            <div class="con" v-if="info.Type === 4">{{ i18n.ProductAccount }}</div>
            <div class="con" v-if="info.Type === 5">{{ i18n.Modelaccount }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.FreeEnergy }}：</div>
            <div class="con">{{ info.GasValue }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.Purchaseenergy }}：</div>
            <div class="con">{{ info.GasBuyValue }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.PlatformRights }}：</div>
            <div class="con" v-if="info.Balance">{{ info.Balance / 1000000000 }}</div>
            <div class="con" v-else></div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.Additionalinformation }}：</div>
            <div class="con"></div>
          </div>
        </div>
      </div>
      <!-- 交易查询 -->
      <div class="info" v-if="queryActive === 2">
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.promoter }}：</div>
            <div class="con">{{ info.from }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.recipient }}：</div>
            <div class="con">{{ info.to }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.transactiontype }}：</div>
            <div class="con" v-if="info.txtype === 1">{{ i18n.Ordinaryactivities }}</div>
            <div class="con" v-if="info.txtype === 2">{{ i18n.Transferactivity }}</div>
            <div class="con" v-if="info.txtype === 3">{{ i18n.Equipmentactivities }}</div>
            <div class="con" v-if="info.txtype === 4">{{ i18n.Contentactivities }}</div>
            <div class="con" v-if="info.txtype === 5">{{ i18n.Platformactivities }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.Transactioncontent }}：</div>
            <div class="con">{{ info.tx_content }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.TransactionNumber }}：</div>
            <div class="con">{{ info.nonce }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.TradingHours }}：</div>
            <div class="con" v-if="info.timeval">{{ (info.timeval / 1000000000) | formatDate }}</div>
            <div class="con" v-else></div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.TransactionStatus }}：</div>
            <div class="con" v-if="info.status === 0">{{ i18n.tradingpool }}</div>
            <div class="con" v-if="info.status === 1">{{ i18n.awaitingconfirmation }}</div>
            <div class="con" v-if="info.status === 2">{{ i18n.Successfultrade }}</div>
            <div class="con" v-if="info.status === 3">{{ i18n.Transactionfailed }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.Transactionresults }}：</div>
            <div class="con">{{ info.return_data }}</div>
          </div>
        </div>
      </div>
      <!-- 区块查询 -->
      <div class="info" v-if="queryActive === 3">
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.blockheight }}：</div>
            <div class="con">{{ info.number }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.Generationtime }}：</div>
            <div class="con" v-if="info.timestamp">{{ (info.timestamp / 1000000000) | formatDate }}</div>
            <div class="con" v-else></div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.FatherBlock }}：</div>
            <div class="con">{{ info.parentHash }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.Packager }}：</div>
            <div class="con">{{ info.miner }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.worldstate }}：</div>
            <div class="con">{{ info.stateRoot }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.TradingRoot }}：</div>
            <div class="con">{{ info.transactionsRoot }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.Receiptroot }}：</div>
            <div class="con">{{ info.receiptsRoot }}</div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.TransactionNumber }}：</div>
            <div class="con">{{ info.Recno }}</div>
          </div>
        </div>
        <div class="infolist">
          <div class="li">
            <div class="desc">{{ i18n.TransactionList }}：</div>
            <div class="con">
              <div v-for="item in info.Txns" :key="item">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'OnChainQuery',
  data() {
    return {
      queryList: [
        {
          id: 1,
          name: '地址查询',
        },
        {
          id: 2,
          name: '交易查询',
        },
        {
          id: 3,
          name: '区块查询',
        },
      ],
      showQuery: false,
      placeholder: '',
      queryActive: 1,
      content: '',
      info: {},
      sliceno: null,
    }
  },
  computed: {
    i18n() {
      return this.$t('OnChainQuery')
    },
  },
  watch: {
    '$i18n.locale'(newLang) {
      if (newLang === 'zh-CN') {
        this.placeholder = '按地址/交易哈希/区块搜索'
      } else if (newLang === 'en-US') {
        this.placeholder = 'Search by address/transaction hash/block'
      }
    },
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.placeholder = '按地址/交易哈希/区块搜索'
    } else if (this.$i18n.locale === 'en-US') {
      this.placeholder = 'Search by address/transaction hash/block'
    }
  },
  mounted() {
    if (this.$route.query.id !== undefined) {
      this.queryActive = Number(this.$route.query.id)
    }
    if (this.$route.query.sliceno !== undefined) {
      this.sliceno = this.$route.query.sliceno
    } else {
      this.sliceno = sessionStorage.getItem('Sliceno')
    }
    if (this.$route.query.content !== undefined) {
      this.content = this.$route.query.content
      if (this.queryActive === 1) {
        this.getaddress()
      } else if (this.queryActive === 2) {
        this.gettransaction()
      } else {
        this.getblock()
      }
    }
  },
  methods: {
    changeQueryActive(item) {
      this.queryActive = item.id
    },
    isHash(value) {
      // const md5Regex = /^0x[a-fA-F0-9]{32}$/ // MD5 哈希值
      // const sha1Regex = /^0x[a-fA-F0-9]{40}$/ // SHA-1 哈希值
      const sha256Regex = /^0x[a-fA-F0-9]{64}$/ // SHA-256 哈希值
      // return md5Regex.test(value) || sha1Regex.test(value) || sha256Regex.test(value)
      return sha256Regex.test(value)
    },
    isValidEthereumAddress(address) {
      const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/
      return ethAddressRegex.test(address)
    },
    isBlockNumber(input) {
      const blockNumberRegex = /^\d+$/ // 非负整数
      return blockNumberRegex.test(input)
    },
    identifyInputType() {
      console.log(this.content)
      if (this.content === '') {
        return false
      } else if (this.isHash(this.content)) {
        console.log('hash')
        this.queryActive = 2
        this.gettransaction()
      } else if (this.isValidEthereumAddress(this.content)) {
        console.log('ethereum address')
        this.queryActive = 1
        this.getaddress()
      } else if (this.isBlockNumber(this.content)) {
        console.log('block number')
        this.queryActive = 3
        this.getblock()
      } else {
        console.log('unknown') // 若不符合任何类别，则标记为未知
        this.content = ''
      }
    },
    // 地址查询
    getaddress() {
      let data = { jsonrpc: '3.0', method: 'chain_queryInfo', params: ['pubChainQuery', `op=queryAddress&value=${this.content}<->latest&sliceno=${this.sliceno}`, 'encryp=none'], id: 1 }
      axios
        .post('https://trust.biots.top', data, {
          header: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res)
          if (res.data.result.ret === '0') {
            this.info = res.data.result.content
          } else {
            alert(res.data.result.err)
          }
        })
    },
    // 交易查询
    gettransaction() {
      let data = { jsonrpc: '3.0', method: 'chain_queryInfo', params: ['pubChainQuery', `op=queryTx&hash=${this.content}&sliceno=${this.sliceno}`, 'encryp=none'], id: 1 }
      axios
        .post('https://trust.biots.top', data, {
          header: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res)
          if (res.data.result.ret === '0') {
            this.info = res.data.result.content[0]
          } else {
            alert(res.data.result.err)
          }
        })
    },
    // 区块查询
    getblock() {
      let data = { jsonrpc: '3.0', method: 'chain_queryInfo', params: ['pubChainQuery', `op=queryBlock&number=${this.content}&sliceno=${this.sliceno}`, 'encryp=none'], id: 1 }
      axios
        .post('https://trust.biots.top', data, {
          header: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res)
          if (res.data.result.ret === '0') {
            this.info = res.data.result.content
          } else {
            alert(res.data.result.err)
          }
        })
    },
  },
}
</script>
<style lang="scss" src="./OnChainQuery.scss" scoped></style>
